import Vue from 'vue'
// import Vuex from 'vuex' see below
import './plugins/toasted'
import './plugins/fontAwesome'
import './directives/common'
import TheRegroupementsPage from './components/TheRegroupementsPage'
import TheFraisTransportTypeAdministrateur from './components/TheFraisTransportTypeAdministrateur'
import TheFraisTransportPage from './components/TheFraisTransportPage'
import TheRegroupementControls from './components/TheRegroupementControls'
import TheMenuCategories from './components/TheMenuCategories'
import TheSearch from './components/TheSearch'
import CaddieTagChantier from './components/CaddieTagChantier.vue'
import ProductTagChantier from './components/atoms/ProductTagChantier.vue'
import ListProductsTagChantier from './components/ListProductsTagChantier.vue'
import TheMenuSelect from './components/TheMenuSelect.vue'
import TheSelectionModelePage from './components/TheSelectionModelePage.vue'
import TheParametrageBaseConnection from './components/TheParametrageBaseConnection.vue'
import SelectClient from './components/SelectClient.vue'
import vSelect from 'vue-select'
import TheDimensionsVariables from './components/TheDimensionsVariables.vue'
import TheDeclinaisonContainer from './components/TheDeclinaisonContainer.vue'
import TheStatistiquesPage from './components/TheStatistiquesPage.vue'
import TheFichierImportationPage from './components/TheFichierImportationPage.vue'
import TheListeCommandesPage from './components/TheListeCommandesPage.vue'
import TheTransporteurPage from './components/TheTransporteurPage'
// import GeolocAgence from './components/GeolocAgence'
import store from './store'

// FIXME Vue.use(Vuex) is already called. But where ?
// Vue.use(Vuex)

Vue.config.productionTip = false

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})
Vue.filter('uppercase', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase()
})
Vue.filter('lowercase', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toLowerCase()
})

window.vueApp = new Vue({

    el: '#app',
    store,
    components: {
        TheFraisTransportPage,
        TheFraisTransportTypeAdministrateur,
        TheRegroupementsPage,
        TheRegroupementControls,
        TheMenuCategories,
        TheSearch,
        CaddieTagChantier,
        ProductTagChantier,
        ListProductsTagChantier,
        TheMenuSelect,
        TheSelectionModelePage,
        TheParametrageBaseConnection,
        TheDeclinaisonContainer,
        vSelect,
        SelectClient,
        TheDimensionsVariables,
        TheStatistiquesPage,
        TheFichierImportationPage,
        TheListeCommandesPage,
        TheTransporteurPage
    }
})
